import type { Contact } from "@roof-hawk/core";

import { t, tn } from "../../i18n";

/**
 * Who this contact is to us, above everything else on their page.
 *
 * Three facts a rep needs before they pick up the phone: whether we have
 * written this person off, whether the system is allowed to email them, and how
 * many of their jobs came to nothing. The last one is the tell for someone who
 * asks for a lot of quotes and never signs.
 *
 * Blacklisting carries "no automated contact" with it — the database enforces
 * that, so unticking it here would simply be undone.
 */
export function ContactFlags({
  contact,
  onSave,
  lostCount,
}: {
  contact: Contact;
  onSave: (patch: Record<string, unknown>) => Promise<void>;
  lostCount: number;
}) {
  return (
    <div className="cflags">
      <div className="cflag-badges">
        <span className="cflag-what">{t("Contact")}</span>
        {contact.blacklisted && (
          <span className="cbadge alert">
            {t("Blacklisted — do not work with")}
          </span>
        )}
        {contact.no_automated_contact && !contact.blacklisted && (
          <span className="cbadge warn">{t("No automated contact")}</span>
        )}
        {lostCount > 0 && (
          <span className="cbadge">
            {tn(lostCount, "1 lost job", "{n} lost jobs")}
          </span>
        )}
      </div>

      <div className="cflag-toggles">
        <label>
          <input
            type="checkbox"
            checked={contact.no_automated_contact}
            disabled={contact.blacklisted}
            onChange={(e) =>
              void onSave({ no_automated_contact: e.target.checked })
            }
          />
          {t("No automated email or text")}
        </label>
        <label>
          <input
            type="checkbox"
            checked={contact.blacklisted}
            onChange={(e) => void onSave({ blacklisted: e.target.checked })}
          />
          {t("Blacklist")}
        </label>
      </div>
    </div>
  );
}
